module.exports = __webpack_public_path__ + "static/media/img-02.e7519a8c.jpg";